<template>
  <swiper
    :modules="modules"
    :slides-per-view="'auto'"
    :looped-slides="list.length"
    :space-between="8"
    :speed="3000"
    :loop="true"
    :autoplay="{ delay: 0, disableOnInteraction: false, }"
    navigation
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <figure :class="{'active': reverse}"><img :src="item.pic" alt="photo"></figure>
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
.swiper{
  @media screen and (max-width: module.$phone){
    transform: translateX(-1.6rem);
    width: calc(100% + 3.2rem);
  }
}
.swiper-slide{
  width: auto;
}
figure{
  &.active{
    transform: translateX(-50%);
  }
}
img{
  width: calc(10rem * .8);
  height: calc(6rem * .8);
  object-fit: contain;
  padding: .2rem;
  image-rendering: auto;
  @media screen and (max-width: module.$phone){
    width: calc(10rem * .5);
    height: calc(6rem * .5);
    padding: .12rem;
  }
}
</style>

<script>
import { ref, toRefs } from 'vue'
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props) {
    const { reverse } = toRefs(props);
    const breakpoints = {
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 10,
      },
      769: {
        spaceBetween: 10,
      },
    };

    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
      reverse,
      breakpoints,
    }
  },
}
</script>
